import api from './api'
import type { Badge } from '../types'

export const badgeApi = {
  getAllBadges: () => api.get<Badge[]>('/badges').then((r) => r.data),
  getBadges: (siteId: string) => api.get<Badge[]>(`/sites/${siteId}/badges`).then((r) => r.data),
  createBadge: (data: Partial<Badge>) => api.post<Badge>('/badges', data).then((r) => r.data),
  updateBadge: (id: string, data: Partial<Badge>) => api.patch<Badge>(`/badges/${id}`, data).then((r) => r.data),
  deleteBadge: (id: string) => api.delete(`/badges/${id}`),
}
